<template>
  <div class="chat-group-header">
    <div class="candidate" v-if="showCandidate()">
      <div class="description">
        <a :href="'/employer/jobs/' + currentChatGroup.job.id + '/candidates'" target="_blank">{{currentChatGroup.job_candidate.user.profile.name}}</a>
        於
        <b>{{formatTime(currentChatGroup.job_candidate.created_at)}}</b>
        應徵了你的工作
      </div>
      <h2>
        <a href="/employer/jobs" target="_blank">{{currentChatGroup.job.title}}</a>
      </h2>
    </div>

    <div class="employer" v-if="showEmployer()">
      <div class="description">
        你於
        <time>{{formatTime(currentChatGroup.job_candidate.created_at)}}</time>
        應徵了此工作
      </div>
      <h2>
        <a href="/account/applied_jobs" target="_blank">{{currentChatGroup.job.title}}</a>
      </h2>
    </div>
  </div>
</template>


<script>

export default {
  props: ['currentChatGroup', 'currentUserId'],
  data() {
    return {
    };
  },
  created() {},


  methods: {
    formatTime(time){
      return moment(time).locale('zh-TW').calendar();
    },

    showCandidate() {
      return this.isEmployer();
    },
    showEmployer() {
      return this.isCandidate();
    },
    isCandidate() {
      return this.currentChatGroup.job_candidate.user.id === this.currentUserId;
    },
    isEmployer() {
      return !this.isCandidate();
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/chat_group_header.vue